import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Equipment.frontend.types'

@Injectable({ providedIn: 'root' })
export class Equipment_remove_warehouse_from_equipmentService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { equipmentId: number, warehouseId: number }): Promise<{ reasons: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.equipmentId)) {
      missingRequiredInParams.push('\'equipmentId\'');
    }
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Equipment/functions/remove_warehouse_from_equipment`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

